module.exports = __webpack_public_path__ + "static/media/delete.2141e00a.svg";